import { render } from "./index.vue?vue&type=template&id=71cc37ca"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/province/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71cc37ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71cc37ca', __exports__)) {
    console.log('reload')
    api.reload('71cc37ca', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=71cc37ca", () => {
    console.log('re-render')
    api.rerender('71cc37ca', render)
  })

}


export default __exports__